import { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import redirects from "../seo/redirects.json";
import { ArrowLeft, Loader2 } from "lucide-react";
import RALayout from "../components/ra/RALayout";
import { API } from "../lib/adventureApi";
import { useSeo } from "../lib/seo";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    let live = true; // ignore late responses for a previous slug (e.g. after a legacy redirect)
    setPost(null); setMissing(false);
    fetch(`${API}/blog/${slug}`).then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((p) => live && setPost(p)).catch(() => live && setMissing(true));
    return () => { live = false; };
  }, [slug]);
  useSeo({ title: post && `${post.title} | Responsible Adventures`, description: post?.excerpt, image: post?.hero_image, type: "article" });

  return (
    <RALayout>
      <article className="max-w-3xl mx-auto px-5 sm:px-8 pt-12 pb-20" data-testid="blog-post">
        <Link to="/blog" className="inline-flex items-center gap-1.5 text-sm text-ink-secondary hover:text-terracotta" data-testid="blog-post-back"><ArrowLeft className="w-4 h-4" /> The Journal</Link>
        {missing && redirects[`/blog/${slug}`] ? (
          <Navigate to={redirects[`/blog/${slug}`]} replace />
        ) : missing ? (
          <p className="mt-10 text-ink-secondary" data-testid="blog-post-missing">This article isn't available right now. <Link to="/blog" className="text-terracotta underline">Browse the journal</Link>.</p>
        ) : !post ? (
          <div className="flex items-center text-ink-secondary py-20"><Loader2 className="w-5 h-5 animate-spin mr-2 text-terracotta" /> Loading…</div>
        ) : (
          <>
            <h1 className="font-display font-extrabold text-3xl sm:text-5xl tracking-tight leading-[1.02] mt-6" data-testid="blog-post-title">{post.title}</h1>
            {post.hero_image && <img src={post.hero_image} alt={post.title} className="mt-8 w-full aspect-[16/9] object-cover rounded-md bg-sand" />}
            <div className="blog-prose mt-8" data-testid="blog-post-body" dangerouslySetInnerHTML={{ __html: post.html }} />
          </>
        )}
      </article>
    </RALayout>
  );
}
